export type MenuItem = {
  id: string;
  label: string;
  href: string;
  children?: MenuItem[];
};

const menuItems: { items: MenuItem[] } = {
  items: [
    {
      id: 'community-members',
      label: 'communityMembers',
      href: '/',
      children: [
        {
          id: 'unlock-early-access',
          label: 'unlockEarlyAccess',
          href: '/unlock-early-access'
        }
      ]
    },
    {
      id: 'brand-partners',
      label: 'BrandPartners',
      href: '/brand-partners',
      children: [
        {
          id: 'apply-store',
          label: 'applyForAStore',
          href: '/brand-partners/apply-store'
        }
      ]
    },
    {
      id: 'contact-us',
      label: "header.contactUs",
      href: '/contact-us'
    }
  ]
};

export default menuItems;
